import React, { useState, useRef, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Tooltip, Button } from '@mui/material';
import Snackbar from '../Snackbar/Snackbar';

import InviteDialog from './InviteDialog';

const InviteLinkButton = styled(Button)({
  cursor: 'pointer',
  padding: '5px 10px',
  marginRight: '20px',
  backgroundColor: '#10416D',
});

const InviteButton: React.FC = () => {
  const [inviteOpen, setInviteOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [apiKey, setApiKey] = useState('');

  useEffect(() => {
    const api_key = window.sessionStorage.getItem('m_key');
    const m_key = api_key ? api_key : "";
    setApiKey(m_key);
  }, [])

  const inviteSuccess = () => {
    setInviteOpen(false);
    setIsSuccess(true);
  }

  // if (true) {
  return (
    <>
      <Snackbar
        variant="info"
        headline="Success"
        message="Call invitation sent..."
        open={isSuccess}
        handleClose={() => setIsSuccess(false)}
      />
      {/* <div className={classes.userContainer}> */}
      <Tooltip title="Having trouble with joining meeting? Let us call you." >
        <InviteLinkButton variant="contained" color="primary" onClick={() => setInviteOpen(true)}
          style={{ color: "white" }}
        >
          Call Me
        </InviteLinkButton>
      </Tooltip >
      {/* </div> */}
      <InviteDialog
        apiKey={apiKey}
        open={inviteOpen}
        onClose={() => {
          setInviteOpen(false);
        }}
        onSuccess={() => {
          inviteSuccess()
        }}
      />
    </>
  );
  // }
  // return null;
};

export default InviteButton;
